// extracted by mini-css-extract-plugin
export var parcelRow = "_qr-0";